
let getModule = () => {
	return import(/* webpackChunkName: "comboboxsModule" */ './ComboboxsModule').then((module) => {
		return module;
	});
}

export default {
	reload: (rootElement?: HTMLElement) => {
		var nodes = (rootElement || document).querySelectorAll(".react-users-combobox, .react-groups-combobox, .react-dictionary-combobox, .react-service-asset-base-data-combobox");
		if (nodes.length != 0) {
			getModule().then(module => {
				for (let i = 0; i < nodes.length; i++) {
					let node = nodes[i] as HTMLElement;
					if (node.classList.contains("react-users-combobox")) {
						module.renderUsersCombobox(node);
					}
					if (node.classList.contains("react-groups-combobox")) {
						module.renderGroupsCombobox(node);
					}
					if (node.classList.contains("react-dictionary-combobox")) {
						module.renderDictionaryCombobox(node);
					}
					if (node.classList.contains("react-service-asset-base-data-combobox")) {
						module.renderServiceAssetBaseDataCombobox(node);
					}
				}
			})
			.catch(error => console.error(error));
		}
	}
} 